//useTypewriter
import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient"; // adjust if in a different location

export default function useUserPlan() {
  const [userPlan, setUserPlan] = useState('free');

  useEffect(() => {
    async function fetchPlan() {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) return;

      const { data, error } = await supabase
        .from('profiles')
        .select('plan')
        .eq('id', user.id)
        .single();

      if (error) {
        console.error("❌ Error fetching user plan:", error);
      }

      if (data?.plan) {
        setUserPlan(data.plan); // 'free', 'professional', or 'elite'
      }
    }

    fetchPlan();
  }, []);

  return userPlan;
}
